<template>
  <div v-if="dataLoad" class="is-height-100p">
    <AppHeader />
    <div class="columns is-marginless">
      <div class="column is-9 pl-20 pt-20 pr-20 pt-100 is-relative">
        <BlocProduits/>
      </div>
      <div class="column is-3 pt-20 pl-0 pr-20 pt-100 is-fixe is-offset-9 is-hidden-touch">
        <BlocInfos/>
      </div>
    </div>
    <div class="column is-marginless is-hidden-desktop">
      <BlocInfosMobile/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import Header from '@/components/general/Header';
import BlocInfos from '@/components/portail/BlocInfos';
import BlocProduits from '@/components/portail/BlocProduits';
import BlocInfosMobile from '@/components/portail/BlocInfosMobile';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  components: {
    AppHeader: Header,
    BlocInfos,
    BlocProduits,
    BlocInfosMobile,
  },
  data() {
    return {
      dataLoad: false,
    };
  },
  methods: {
    ...Recommandation.mapActions({
      actionsGetRecom: 'getRecom',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.actionsGetRecom();
      this.dataLoad = true;
    } catch (e) {
      gestionErreur('Erreur serveur');
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
